<template>
  <footer class="footer-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="single-footer-widget">
            <h6 class="footer_title">
              About Us
            </h6>
            <p>
              Pet Queen was born out of a mission to provide a more accessible and enjoyable pet
              adoption experience for everyone. With the goal of creating a user-friendly platform,
              you took the first step by designing an intuitive interface where users could easily
              access the information they were looking for...
            </p>
            <a href="">Continue to read...</a>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 yarim">
          <div class="single-footer-widget">
            <h6 class="footer_title">
              Legal
            </h6>
            <ul>
              <li><a href="/legal/">About Us</a></li>
              <li><a href="/privacy_and_cookie_policy/">Privacy Policy</a></li>
              <li><a href="/terms_and_conditions/">Terms & Conditions</a></li>
              <li><a href="#">Refund Policy</a></li>
              <li><a href="/lucys/">Lucys Law</a></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6 yarim">
          <div class="single-footer-widget f_social_wd">
            <h6 class="footer_title">
              Follow Us
            </h6>
            <p>Let us be social</p>
            <div class="f_social">
              <a href="#"><font-awesome-icon :icon="['fab', 'facebook']" /></a>
              <a href="#"><font-awesome-icon :icon="['fab', 'twitter']" /></a>
              <a href="#"><font-awesome-icon :icon="['fab', 'instagram']" /></a>
              <a href="#"><font-awesome-icon :icon="['fab', 'tiktok']" /></a>
              <a href="#"><font-awesome-icon :icon="['fab', 'pinterest']" /></a>
              <a href="#"><font-awesome-icon :icon="['fab', 'youtube']" /></a>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="single-footer-widget instafeed">
            <h6 class="footer_title">
              Instagram Feed
            </h6>
          </div>
        </div>
      </div>
      <div class="row footer-bottom d-flex justify-content-between align-items-center">
        <p class="col-lg-12 footer-text text-center">
          Copyright &copy; All rights reserved | Powered by <a>Neural Networks</a> using the
          <i
            class="icon-brain"
            aria-hidden="true"
            style="font-size: 20px"
          />
        </p>
      </div>
    </div>
    <!-- Back to top button -->
    <button
      v-if="showBackToTop"
      id="btn-back-to-top"
      type="button"
      class="btn btn-danger btn-floating btn-lg"
      @click="backToTop"
    >
      <i class="fas fa-arrow-up" />
    </button>
  </footer>
</template>
<script setup>
  import { ref, onMounted, onBeforeUnmount } from 'vue';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

  const showBackToTop = ref(false);

  function scrollFunction() {
    showBackToTop.value = window.scrollY > 200;
  }

  function backToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  onMounted(() => {
    if (!window.matchMedia('(max-width: 768px)').matches) {
      window.addEventListener('scroll', scrollFunction);
    }
  });

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', scrollFunction);
  });
</script>
<style>
  .fa {
    display: inline-block;
    font: normal normal normal 14px/1 FontAwesome;
    font-size: inherit;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .fa-twitter:before {
    content: '\f099';
  }
  .footer-area {
    background: #fbf8f8;
    padding-top: 50px;
    padding-bottom: 15px;
  }

  .single-footer-widget p {
    margin-bottom: 0px;
    color: #75747c;
    max-width: 535px;
  }
  .single-footer-widget ul {
    padding-left: 1rem;
  }
  .single-footer-widget ul li a {
    line-height: 25px;
    display: inline-block;
    color: #777;
    -webkit-transition: all 0.3s linear;
    -o-transition: all 0.3s linear;
    transition: all 0.3s linear;
    margin-bottom: 13px;
  }

  .single-footer-widget ul li a:hover {
    color: #003158;
  }

  .single-footer-widget .instafeed {
    margin-left: -5px;
    margin-right: -5px;
  }

  .single-footer-widget .instafeed li {
    margin: 5px;
  }

  .single-footer-widget .subscribe_form {
    padding-top: 25px;
  }

  single-footer-widget .input-group {
    display: block !important;
  }

  .single-footer-widget input {
    width: 100%;
    border: 1px solid #fff;
    font-size: 13px;
    line-height: 30px;
    padding-right: 40px;
    height: 40px;
    color: #999999;
    background: #fff;
    padding-left: 20px;
  }

  .single-footer-widget input.placeholder {
    color: #999999;
  }

  .single-footer-widget input:-moz-placeholder {
    color: #999999;
  }

  .single-footer-widget input::-moz-placeholder {
    color: #999999;
  }

  .single-footer-widget input::-webkit-input-placeholder {
    color: #999999;
  }

  .single-footer-widget input:focus {
    outline: none;
  }

  .single-footer-widget .sub-btn {
    background: #003158;
    color: #fff;
    font-weight: 300;
    border-radius: 0;
    line-height: 34px;
    padding: 4px 11px 0px;
    cursor: pointer;
    position: absolute;
    right: 0px;
    top: 0px;
  }

  .single-footer-widget .sub-btn span {
    position: relative;
    top: -1px;
  }

  .footer_title {
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    color: #888888;
    margin-bottom: 28px;
  }

  .f_social_wd p {
    font-size: 14px;
    color: #75747c;
    margin-bottom: 15px;
  }

  .f_social_wd .f_social a {
    font-size: 14px;
    color: #75747c;
    -webkit-transition: all 0.3s linear;
    -o-transition: all 0.3s linear;
    transition: all 0.3s linear;
    margin-right: 20px;
  }

  .f_social_wd .f_social a:hover {
    color: #003158;
  }

  .f_social_wd .f_social a:last-child {
    margin-right: 0px;
  }
  #btn-back-to-top {
    position: fixed;
    bottom: 45px;
    right: 20px;
    z-index: 30;
    background-color: white;
    border: 1px solid #d78be2;
  }
  #btn-back-to-top:hover {
    color: crimson;
  }

  @media screen and (max-width: 492px) {
    .footer-area .yarim {
      width: 50%;
    }
    .single-footer-widget p {
      max-width: 100% !important;
    }

    .single-footer-widget ul {
      padding-left: 0.5rem;
    }
    .single-footer-widget ul li a {
      line-height: 15px !important;
      display: inline-block !important;
      color: #777;
      -webkit-transition: all 0.3s linear !important;
      -o-transition: all 0.3s linear !important;
      transition: all 0.3s linear !important;
      margin-bottom: 7px !important;
    }
  }

  @media (max-width: 575px) {
    .footer-area {
      padding: 70px 0px;
    }
  }
  @media (max-width: 991px) {
    .footer-area .col-sm-6 {
      margin-bottom: 30px;
    }

    #btn-back-to-top {
      top: 20px;
      bottom: unset !important;
      z-index: 99 !important;
    }
    .footer-area {
      padding: 70px 0px;
    }
  }
  @media (min-width: 992px) {
    .footer-area .col-lg-4 {
      flex: 0 0 auto;
      width: 19.933333%;
    }
  }
</style>
